import type { PlantConfig } from '../engine/plant/types';
import { waterTreatmentPlant } from './water-treatment';
import { cstrUnit } from './cstr-unit';
import { crudeUnit } from './crude-unit';

export const allPlants: PlantConfig[] = [waterTreatmentPlant, cstrUnit, crudeUnit];

export const plantById = (id: string): PlantConfig | undefined =>
  allPlants.find((p) => p.id === id);

export { waterTreatmentPlant, cstrUnit, crudeUnit };
